import { Avatar, Badge, CollectionItem } from '@ksyos/design-system';
import type { AccountRequestApiResult } from '@common/interfaces/api/accountRequestsApi';
import { AccountRequestStatus } from '@common/enums/accountRequestStatus';
import { formatString } from '@common/utils/formatString';
import { getDisplayInitials } from '@common/utils/getDisplayInitials';
import { getDisplayName } from '@common/utils/getDisplayName';
import { getSelectedLanguage } from '@frontend/translate';
import { PendingAccountRequestBadge } from './PendingAccountRequestBadge';

interface AccountRequestsCollectionItemProps {
    accountRequest: AccountRequestApiResult;
    avatarSize?: number;
    padding?: 'small' | 'medium';
}

export function AccountRequestsCollectionItem(props: Readonly<AccountRequestsCollectionItemProps>) {
    const language = getSelectedLanguage();

    return (
        <CollectionItem
            key={props.accountRequest.id}
            mediaItem={
                <Avatar
                    initials={getDisplayInitials(props.accountRequest.userData.practitioner)}
                    size={props.avatarSize}
                />
            }
            padding={props.padding}
            subtitle={language.professionEnum[props.accountRequest.userData.employment.profession]}
            title={getDisplayName(props.accountRequest.userData.practitioner, false, 'nameGivenNameFamily')}
        >
            {props.accountRequest.status === AccountRequestStatus.pending &&
                (props.accountRequest.approverPractitionerId ? (
                    <PendingAccountRequestBadge approverPractitioner={props.accountRequest.approverPractitioner} />
                ) : (
                    <Badge
                        size="medium"
                        text={
                            props.accountRequest.hasMatchedOnNameAndGender
                                ? language.accountRequest.ksyosReviewsRequest
                                : formatString(language.organization.pendingApprovalOf, ['Ksyos'])
                        }
                    />
                ))}
        </CollectionItem>
    );
}
